import { Typography, Paper, Skeleton } from '@mui/material'

import './TrayComponent.scss'
import { TrayComponentProps } from './TrayComponent.types'
import useTrayComponentLogic from './TrayComponent.logic'
import useDTMS3Image from 'lib/utils/useDTMS3Image'

const TrayComponent = ({ parentTray, subTray }: TrayComponentProps) => {
  const {
    handleTrayClick,
    areThereAssets,
    areThereScrews,
    areTherePlates,
    screws,
    plates,
    customImplants,
    manufacturer,
    trayImage,
    isInstrumentOnly,
    isCustomImplantTray,
  } = useTrayComponentLogic({ parentTray, subTray })

  const { imageUrl, isLoading: isImageLoading } = useDTMS3Image({
    url: trayImage,
    defaultImage: '',
  })

  return (
    <Paper
      className="tray-component"
      onClick={handleTrayClick}
      elevation={1}
      role="button"
      aria-label={`View details for ${subTray.description}`}
      tabIndex={0}
    >
      <div className="tray-image-container">
        {isImageLoading ? (
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            animation="wave"
            className="tray-image-skeleton"
          />
        ) : (
          <img
            src={imageUrl}
            alt={subTray.description}
            className="tray-image"
          />
        )}
      </div>
      <div className="status-badge">
        <span className="status-dot" />
        Loaded from SPD
      </div>
      <div className="tray-stats">
        {areThereScrews && (
          <div className="stat-item">
            <span className="stat-value">{screws.length}</span>
            <span className="stat-label">Screws</span>
          </div>
        )}
        {areTherePlates && (
          <div className="stat-item">
            <span className="stat-value">
              {plates
                .map((plate) => plate.plateCount)
                .reduce((a, b) => a + b, 0)}
            </span>
            <span className="stat-label">Plates</span>
          </div>
        )}
        {isCustomImplantTray && (
          <div className="stat-item">
            <span className="stat-value">{customImplants.length}</span>
            <span className="stat-label">Custom Implants</span>
          </div>
        )}
        {!areThereAssets && !isInstrumentOnly && !isCustomImplantTray && (
          <div className="stat-item">
            <span className="stat-value">0</span>
            <span className="stat-label">Screws or Plates</span>
          </div>
        )}
        {isInstrumentOnly && (
          <div className="stat-item">
            <span className="stat-label">Instruments Only</span>
          </div>
        )}
      </div>
      <div className="tray-overlay">
        <Typography className="tray-title">{subTray.description}</Typography>
        <div className="total-count">
          <span className="count-label">{manufacturer}</span>
        </div>
      </div>
    </Paper>
  )
}

export default TrayComponent
